// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1kELg","title":"ClientReferral_title__1xpoM","itemText":"ClientReferral_itemText__3St-r"};